import { render, staticRenderFns } from "./main-breadcrumb.vue?vue&type=template&id=4f1acbf8&scoped=true"
import script from "./main-breadcrumb.vue?vue&type=script&lang=js"
export * from "./main-breadcrumb.vue?vue&type=script&lang=js"
import style0 from "./main-breadcrumb.vue?vue&type=style&index=0&id=4f1acbf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1acbf8",
  null
  
)

export default component.exports